import React, { useCallback } from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { Bold } from '~/components'
import { CheckIcon } from '~/assets/icons'
import { mutualTheme } from '~/utils/theme'

export type SubStepProps = {
  title: string,
  currentPage: number,
  subStepIndex: number
}

const useStyles = makeStyles({
  container: (props: SubStepProps) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: mutualTheme.spacing(3),
    marginLeft: props.currentPage > props.subStepIndex ? 48 : 80
  }),
  icon: {
    marginRight: mutualTheme.spacing(1)
  }
})

export const SubStep = (props: SubStepProps) => {
  const { currentPage, subStepIndex, title } = props
  const classes = useStyles(props)

  const getColor = useCallback(() => {
    return currentPage === subStepIndex ? mutualTheme.palette.secondary.main : mutualTheme.palette.textGray2.main
  }, [currentPage, subStepIndex])

  return (
    <Box className={classes.container}>
      {currentPage > subStepIndex && <CheckIcon className={classes.icon} color={'#05C370' as any} />}
      <Typography style={{ color: getColor() }} ><Bold>{title}</Bold></Typography>
    </Box>
  )
}
